import creditCardType from "credit-card-type";
import AmEx from "./Icons/AmEx";
import Diners from "./Icons/Diners";
import Discover from "./Icons/Discover";
import JCB from "./Icons/JCB";
import Mastercard from "./Icons/Mastercard";
import Unknown from "./Icons/Unknown";
import Visa from "./Icons/Visa";

// Icons from https://awesomeopensource.com/project/aaronfagan/svg-credit-card-payment-icons

function CreditCardIcon({
  className = "",
  number,
  typeCode,
}: {
  className?: string;
  number?: string;
  typeCode?: string;
}) {
  const iconProps = { className: `${className} rounded-lg drop-shadow grayscale h-12 w-16` };
  if (!number && !typeCode) return <Unknown {...iconProps} />;

  // If we have a type code use that, otherwise use the number
  let typeFromNumber;
  if (!typeCode && number) {
    typeFromNumber = creditCardType(number)[0];
    typeFromNumber = typeFromNumber ? typeFromNumber.type : "Unknown";
  }

  const typeKey = typeCode || typeFromNumber;
  const TypeIcon = !typeKey
    ? Unknown
    : {
        A: AmEx,
        "american-express": AmEx,
        D: Discover,
        "diners-club": Diners,
        discover: Discover,
        J: JCB,
        jcb: JCB,
        M: Mastercard,
        mastercard: Mastercard,
        MC: Mastercard,
        R: Diners,
        V: Visa,
        visa: Visa,
      }[typeKey] || Unknown;

  return <TypeIcon {...iconProps} />;
}

export default CreditCardIcon;
